import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.useUnauthorisedHandler || initialState;

export const selectUseUnauthorisedHandler = createSelector(
  [selectSlice],
  state => state,
);

export const selectUnauthorisedFlag = createSelector(
  [selectSlice],
  state => state.unauthorised,
);
